export interface IExtraMemberAccessible {
  applyExtraMembers(source: any, destination: any): void;
}

export function instanceOfIExtraMemberAccessible(instance: any): instance is IExtraMemberAccessible {
  return instance
    && (instance.applyExtraMembers !== undefined);
}
